import React = require("react");
import { hyphen } from "../../../Shared/utils/hyphenate";
import { JumboProps, isHomeJumbo, renderContents } from "../../custom_components/components/jumbo";
import { LinkButton } from "../../custom_components/components/library/button";
import { trackJumboButton } from "../../custom_components/components/library/tracking";
import { BranchLocalizationLayout } from "../../../Shared/components/Jumbo/BranchLocalization/BranchLocalizationLayout";

const homeJumbo = (props: JumboProps) => 
<header className="jumbotron jumbotron--newlarge">
  <div className="jumbotron__outer">
    <div className="jumbotron__inner">
      {isHomeJumbo(props) && <BranchLocalizationLayout {...props.localizationProps}/>}
      <div className="jumbotron__top">
        <div className="jumbotron__top-inner container--mg align--center">
          <h1 className="jumbotron__title title--xl">{hyphen(props.title)}</h1>
        </div>

        {props.imageUrl && (
          <picture className="jumbotron__visual jumbotron__visual--mob" aria-hidden="true">
            <source srcSet="/bkw/images/bkw/empty.png" media="(min-width: 768px)" />
            <img
              src="/bkw/images/bkw/empty.png"
              srcSet={`${props.imageUrl} 440w, ${props.imageUrlLarge} 880w`}
              width="440"
              height="440"
              alt={props.imageAlt}
            />
          </picture>
        )}
      </div>

      <div className="jumbotron__bottom">
        <div className="jumbotron__bottom-inner container--mg align--center">
          {props.contents.toString().length > 0 || (props.buttonUrl && props.buttonTitle) ? (
            <div className="jumbotron__intro">
              <div className="text--styled">
                {props.contents.toString().length > 0 && (
                  renderContents(
                    props.contents,
                    <div />,
                    <div />
                  )
                )}
              </div>

              {props.buttonUrl && props.buttonTitle && (
                <LinkButton
                  variant="black"
                  arrow={false}
                  route={props.buttonUrl}
                  handle={() => trackJumboButton(props.buttonTitle)}
                  className="button button--primary button--arrow jumbotron__clickable"
                >
                  <span className="button__label">{props.buttonTitle}</span>
                </LinkButton>
              )}
            </div>
          ) : <></>}

          {props.imageUrl && (
            <picture className="jumbotron__visual jumbotron__visual--desk" aria-hidden="true">
              <source srcSet={`${props.imageUrl} 440w, ${props.imageUrlLarge} 880w`} media="(min-width: 768px)" />
              <img
                src="/bkw/images/bkw/empty.png"
                width="440"
                height="440"
                alt={props.imageAlt}
              />
            </picture>
          )}
        </div>
      </div>
    </div>
  </div>
</header>

export default homeJumbo